import {
	API_SEARCH_COMPANY,
	API_ADMIN_GET_ALL_COMPANY,
	API_ADMIN_GET_COMPANY,
    ADMIN_RESET_FOCUS_COMPANY,
} from 'actions/company';
import { DEFAULT_CLIENT, V2_CLIENT } from "config/clientConstants";

export const getVersion = (action) => {
	const path = pathMapping[action];
	return {
		path: path ? path[path.currentClient] : undefined,
		currentClient: path ? path.currentClient : DEFAULT_CLIENT,
	}
}

const pathMapping = {
	[API_SEARCH_COMPANY]: {
		default: (size, start) => `/companies/search/${size}/${start}`,
		v2: (size, start) => `/companies/search/${size}/${start}`,
		currentClient: DEFAULT_CLIENT,
	},
	[API_ADMIN_GET_ALL_COMPANY]: {
		default: () => `/admin/companies`,
		v2: () => `/companies/admin`,
		currentClient: DEFAULT_CLIENT,
	},
	[API_ADMIN_GET_COMPANY]: {
		default: (id) => `/admin/companies/${id}`,
		v2: (id) => `/companies/admin/${id}`,
		currentClient: DEFAULT_CLIENT,
	},
};

export function searchCompanies(searchData, size, start) {
	const version = getVersion(API_SEARCH_COMPANY);
	const url = typeof version.path === 'function' ? version.path(size, start) : version.path;
	return {
		type: API_SEARCH_COMPANY,
		payload: {
			client: version.currentClient,
			request: {
				url,
				method: 'GET',
				params: searchData
			}
		}
	};
}

export function adminGetAllCompanies() {
	const version = getVersion(API_ADMIN_GET_ALL_COMPANY);
	const url = typeof version.path === 'function' ? version.path() : version.path;
	return {
		type: API_ADMIN_GET_ALL_COMPANY,
		payload: {
			client: version.currentClient,
			request: {
				url
			}
		}
	};
}

export function adminGetCompany(company) {
	const version = getVersion(API_ADMIN_GET_COMPANY);
	const url = typeof version.path === 'function' ? version.path(company.id) : version.path;
	return {
		type: API_ADMIN_GET_COMPANY,
		payload: {
			client: version.currentClient,
			request: {
				url
			}
		}
	};
}

export function resetFocusCompany() {
	return {
		type: ADMIN_RESET_FOCUS_COMPANY
	};
}
